module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAA1klEQVQokZXSP0oDQRiG8d8OaWxiEz1ACrWz0VssNkEPkF4QK+2FtBLS6gXiNoKnsLCxsPIAwSpBBS1isTOyBBk3TzV/3udjmO8rPi4ONOjhHCV24tkL7jHGWwoWDXGAG2z6mzmGqCA0pGlGgm7MDJK4hVsUGen3hTG7HXAaq7Wli7OAozWkRNnBXtptjB6z6c/Lw7TcDblghq+Ouk/7KxX/4zWom7suDwETdXPbMsd1wEw9EcsW0jJmZ+lzKpxgkZEWOLYycnCHPkZ4xjfe8YSreFel8A9rrSp2moTTlQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error_msg.png
// module id = 241
// module chunks = 1